import { render } from "./Homeboard.vue?vue&type=template&id=b347dd92"
import script from "./Homeboard.vue?vue&type=script&lang=js"
export * from "./Homeboard.vue?vue&type=script&lang=js"

import "./Homeboard.vue?vue&type=style&index=0&id=b347dd92&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__